<template>
  <div class="page">
    <div class="name">支付聚合平台</div>
    <div class="content">
      <!-- 左侧图案 -->
      <leftImg></leftImg>
      <!-- 注册 -->
      <div class="right">
        <p class="name">注册</p>
        <div class="info">我们将发送验证邮件到您的邮箱，该邮箱号<br />将作为登录用户名</div>
        <div class="form">
          <el-input
            class="mailbox"
            v-model="emailAccount"
            @input="changeStatus"
            placeholder="请输入邮箱地址"
          ></el-input>
          <div class="agreement">
            <el-checkbox v-model="checkAgreement" @change="changeStatus"></el-checkbox>
            <p>
              我已阅读并同意<span>《用户协议》</span>和<span>《隐私<br />权协议》</span>
            </p>
          </div>
          <el-button
            :class="[!btnStatus ? 'btn-status' : '', 'btn']"
            type="primary"
            @click="btnStatus ? sendCode() : ''"
            >发送验证邮件</el-button
          >
          <div class="back">
            <span>已有账号？</span>
            <span @click="backLogin('login')">返回登录</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import leftImg from '@login/components/leftImg';
import checkString from '@/util/CheckString';
export default {
  components: {
    leftImg,
  },
  data() {
    return {
      emailAccount: '', // 邮箱地址
      checkAgreement: false, // 用户协议
      btnStatus: false, // 按钮可点击状态
    };
  },
  methods: {
    ...mapActions('login', ['getEmailVerifyCode']),
    // 发送验证码
    async sendCode() {
      // 格式校验
      const formatRes = this.handleCheckString();
      if (!formatRes) return;
      // 校验通过 => 发送邮箱验证码并跳转下一页
      try {
        this.btnStatus = false;
        const authKey = await this.getEmailVerifyCode({ account: this.emailAccount });
        if (authKey) {
          this.$router.push({
            path: '/register/stepTwo',
            query: { emailAccount: this.emailAccount },
          });
          return;
        }
        // 验证邮件返回值异常
        this.$message.error('验证邮件发送失败，请重试');
        this.btnStatus = true;
      } catch (error) {
        this.btnStatus = true;
        console.error(error);
      }
    },
    // 修改邮箱/协议选中状态
    changeStatus() {
      if (this.emailAccount != '' && this.checkAgreement === true) {
        this.btnStatus = true;
      } else {
        this.btnStatus = false;
      }
    },
    // 返回登录
    backLogin() {
      this.$router.back(-1);
    },
    // 邮箱格式校验
    handleCheckString() {
      const checkRes = checkString(this.emailAccount, 'email');
      if (!checkRes) {
        this.$message.error('邮箱地址格式错误');
        return false;
      }
      return true;
    },
  },
};
</script>

<style lang="less" scoped>
.page {
  height: 90vh;
  display: flex;
  flex-direction: column;
  padding: 5vh;
}
.name {
  font-size: 22px;
  color: #333;
  font-family: Noto Sans S Chinese;
  font-weight: 400;
}
.content {
  display: flex;
  width: 800px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 3px 6px rgba(67, 89, 183, 0.2);
  border-radius: 8px;
  margin: auto;
}
.right {
  width: 50%;
  height: 400px;
  .name {
    font-size: 22px;
    color: #333;
    padding: 18px 0;
    text-align: center;
  }
  .info {
    font-size: 14px;
    padding: 0 0 5px 65px;
    line-height: 25px;
  }
  .form {
    text-align: center;
  }
  .mailbox {
    width: 300px;
  }
  .agreement {
    display: flex;
    width: 262px;
    font-size: 14px;
    color: #333;
    text-align: left;
    margin: auto;
    padding-top: 10px;
    span {
      color: #4359b7;
      cursor: pointer;
    }
    p {
      margin: 0 0 0 10px;
    }
  }
  .btn {
    width: 300px;
    font-size: 14px;
    font-family: Helvetica Neue;
    font-weight: 400;
    margin: 20px 0;
  }
  .btn-status {
    opacity: 0.4;
  }
  .back {
    font-size: 14px;
    color: #666;
    span:nth-child(2) {
      color: #4359b7;
      cursor: pointer;
    }
  }
}
</style>
